import { GlobalStyle } from '@devrangex/rui'
import { Global, ThemeProvider } from '@emotion/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { RecoilRoot } from 'recoil'

import Fallback from './Fallback'
import HomePage from './pages/Home'
import LoginPage from './pages/Login'
import RankPage from './pages/Rank'
import { dark } from './styles/theme'
import Sentry from './utils/Sentry'


export default function App() {
  return (
    <ThemeProvider theme={dark}>
      <Global styles={GlobalStyle(dark)}/>
      <Sentry.ErrorBoundary fallback={<Fallback/>}>
        <RecoilRoot>
          <QueryClientProvider client={new QueryClient()}>
            <BrowserRouter basename="/">
              <Routes>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/login" element={<LoginPage/>}/>
                <Route
                  path="/rank/:competitionID"
                  element={<RankPage/>}
                />
              </Routes>
            </BrowserRouter>

            <ToastContainer
              style={{
                width: 480,
                whiteSpace: 'pre-line',
              }}
            />
          </QueryClientProvider>
        </RecoilRoot>
      </Sentry.ErrorBoundary>
    </ThemeProvider>
  )
}
